import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';

import { UsersResource } from '../../../services/resources/users.resource';
import { AppSessionStorage } from '../../../services/storage/app.session-storage';
import { SecurityStorage } from '../../../services/storage/security.storage';
import { TranslationService } from '../../../services/translation.service';

@Component({
    selector: 'sl-terms-of-service',
    templateUrl: './terms-of-service.dialog.html',
    styleUrls: ['./terms-of-service.dialog.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TermsOfServiceDialog implements OnInit {
    readonly isLoading = signal(false);
    readonly linkTos = signal('');
    readonly linkPrivacyStatement = signal('');

    private readonly securityStorage = inject(SecurityStorage);
    private readonly usersResource = inject(UsersResource);
    private readonly translationService = inject(TranslationService);
    private readonly appSessionStorage = inject(AppSessionStorage);
    private readonly matDialogRef = inject(MatDialogRef);

    ngOnInit(): void {
        const context = this.appSessionStorage.getCurrentContext();
        const langCode = this.translationService.getCurrent().code;

        // TODO if not netvote user, the link will be different
        this.linkTos.set(`https://${context}.netvote.ch/auth/tos_netvote_${langCode}.html`);
        this.linkPrivacyStatement.set(`https://${context}.netvote.ch/auth/privacystatement_${context}_netvote_${langCode}.html`);
    }

    acceptTos(): void {
        this.usersResource
            .acceptTos()
            .pipe(finalize(() => this.isLoading.set(false)))
            .subscribe(response => {
                const userInfo = this.securityStorage.getUserInfo()!;
                this.securityStorage.saveUserInfo({ ...userInfo, acceptedTosDate: response.value.result });
                this.matDialogRef.close(true);
            });
    }
}
